import { useState, useEffect, useRef } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import Style from "./css/style.module.css";
import TitleArea from "./area/title";
import StudySortArea from "./area/study_sort";
import WordTestResultArea from "./area/word_test_result";

function ViewTodoWordResultOneArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    todo_pri_val_arr: [],
    ...props
  };

  let user = useSelector((state: any) => state.user);
  const [todo_info, set_todo_info] = useState<any>(null);
  const [word_pre_info, set_word_pre_info] = useState<any>(null);
  const [word_data_arr, set_word_data_arr] = useState<any>([]);

  useEffect(() => {
    get_todo_info_arr_by_ajax({
      todo_pri_val_arr: myProps.todo_pri_val_arr
    });
  }, []);

  const get_todo_info_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      "todo_pri_val_arr": myProps.todo_pri_val_arr,
      "is_reverse": true,
      ...inData
    };

    if (strFunc.is_empty(opt_obj.todo_pri_val_arr)) {
      return false;
    }

    let list_form_json = {
      "s_pri_arr": opt_obj.todo_pri_val_arr,
      "is_paging": "",
      "s_addon_par_content": "1",
      "s_addon_comp_user": "1",
      "s_addon_mcomp_title": "1",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/list', list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let todo_info_item = response.data["data"]["info_arr"][0];
            set_todo_info(todo_info_item);

            let row_word_data_arr = [];
            if (todo_info_item && todo_info_item.mtextbook_info
              && todo_info_item.mtextbook_info.study_arr
            ) {
              let row_study_arr = todo_info_item.mtextbook_info.study_arr;
              for (let s_i = 0; s_i < row_study_arr.length; s_i++) {
                let row_study = row_study_arr[s_i];
                if (row_study.cg_word_arr) {
                  for (let i = 0; i < row_study.cg_word_arr.length; i++) {
                    let row_word = row_study.cg_word_arr[i];
                    row_word_data_arr.push(row_word);
                  }
                }
              }
            }
            if (todo_info_item && todo_info_item.word_inside_info
              && todo_info_item.word_inside_info.cg_word_arr
            ) {
              row_word_data_arr = todo_info_item.word_inside_info.cg_word_arr;
            }

            let row_select_word_data_arr = [];
            let row_start_idx = strFunc.uncomma_int(todo_info_item.a_success_amount_start);
            let row_word_cnt = strFunc.uncomma_int(todo_info_item.a_success_amount);
            for (let w_i = 0; w_i < row_word_data_arr.length; w_i++) {
              if (w_i >= row_start_idx && w_i < (row_start_idx + row_word_cnt)) {
                row_select_word_data_arr.push(row_word_data_arr[w_i]);
              }
            }

            let row_word_data_arr2: any = [];
            for (let i = 0; i < row_select_word_data_arr.length; i++) {
              let row_data = row_select_word_data_arr[i];
              let word_data = {
                uid: i + 1,
                cont_part: row_data.a_cont_part,
                e_script: row_data.a_word,
                k_script: row_data.a_mean,
                mp3_file: "",
                cont_class: row_data.a_cont_part == "word" ? "VOCA" : "4-skills",
                mp3_file_url: "",
              };
              if (row_data.word_file_info && row_data.word_file_info.img_url) {
                word_data.mp3_file_url = row_data.word_file_info.img_url;
              }

              row_word_data_arr2.push(word_data);
            }
            set_word_data_arr(row_word_data_arr2);

            get_word_pre_info_by_ajax({
              todo_seq: todo_info_item.row_pri_val,
              stu_seq: todo_info_item.a_stu_mcomp_user_seq,
              word_data_arr: row_word_data_arr2
            });
          }
        } else {
          alert("검색 중 오류." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  const get_word_pre_info_by_ajax = (inData: any) => {
    let opt_obj = {
      todo_seq: "",
      stu_seq: "",
      word_data_arr: [],
      ...inData
    };
    if (strFunc.is_empty(opt_obj.todo_seq)) {
      return false;
    }
    if (strFunc.is_empty(opt_obj.stu_seq)) {
      return false;
    }
    let form_json: any = {
      s_mcomp_seq: "",
      stu_seq: opt_obj.stu_seq,
      coolen_study_par_id: "todo",
      coolen_study_par_seq: opt_obj.todo_seq,
      word_data_arr: opt_obj.word_data_arr,

      // pre_s_start_date: "",
      // pre_s_end_date: "",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/save_study/get_study_data', form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_word_pre_info(response.data["data"]);
        } else {
          alert("검색 중 오류." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  return (
    <div className={Style.popup_wrap}>
      <TitleArea
        Style={Style}
        todo_info={todo_info}></TitleArea>
      {word_pre_info &&
        <StudySortArea
          Style={Style}
          todo_info={todo_info}
          word_pre_info={word_pre_info}
          word_data_arr={word_data_arr}
        ></StudySortArea>
      }
      <div>
        <WordTestResultArea
          Style={Style}
          todo_info={todo_info}
          word_pre_info={word_pre_info}
          word_data_arr={word_data_arr}
        ></WordTestResultArea>
      </div>
    </div>
  );
};
export default ViewTodoWordResultOneArea;